class CartBirthday {
  constructor() {
    document.addEventListener('input', (e) => {
      if (e.target.id === 'cart_birthday_input') this.handleInput(e);
    });

    document.addEventListener('click', (e) => {
      if (e.target.closest('#cart_checkout_btn')) this.handleCheckout(e);
    });
  }

  get input() {
    return document.getElementById('cart_birthday_input');
  }

  get error() {
    return document.getElementById('cart_birthday_error');
  }

  get checkoutBtn() {
    return document.getElementById('cart_checkout_btn');
  }

  handleInput(e) {
    let value = e.target.value.replace(/\D/g, '');
    let formatted = '';

    if (value.length <= 2) {
      formatted = value;
    } else if (value.length <= 4) {
      formatted = `${value.slice(0, 2)} / ${value.slice(2)}`;
    } else {
      formatted = `${value.slice(0, 2)} / ${value.slice(2, 4)} / ${value.slice(4, 8)}`;
    }

    e.target.value = formatted;
    this.clearError();
  }

  isValidDate(value) {
    const digits = value.replace(/\D/g, '');
    if (digits.length !== 8) return false;

    const day = parseInt(digits.slice(0, 2), 10);
    const month = parseInt(digits.slice(2, 4), 10);
    const year = parseInt(digits.slice(4, 8), 10);

    if (month < 1 || month > 12) return false;
    if (day < 1 || day > 31) return false;
    if (year < 1900 || year > new Date().getFullYear()) return false;

    const date = new Date(year, month - 1, day);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
  }

  showError() {
    const error = this.error;
    const input = this.input;
    if (error) error.hidden = false;
    if (input) input.classList.add('cart_birthday__input--error');
  }

  clearError() {
    const error = this.error;
    const input = this.input;
    if (error) error.hidden = true;
    if (input) input.classList.remove('cart_birthday__input--error');
  }

  async handleCheckout(e) {
    const input = this.input;

    if (!input) return;

    e.preventDefault();

    const value = input.value.trim();

    if (value.length > 0 && !this.isValidDate(value)) {
      this.showError();
      input.focus();
      return;
    }

    const btn = this.checkoutBtn;
    if (btn) btn.classList.add('loading');

    if (value.length === 0) {
      window.location.href = '/checkout';
      return;
    }

    const digits = value.replace(/\D/g, '');
    const formatted = `${digits.slice(4, 8)}-${digits.slice(2, 4)}-${digits.slice(0, 2)}`;

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { birthday: formatted } }),
      });

      if (!res.ok) throw new Error('cart update failed');
    } catch (err) {
      console.error('[CartBirthday]', err);
    } finally {
      window.location.href = '/checkout';
    }
  }
}

new CartBirthday();
